import { Button, Icon, Modal } from 'antd';
import React, { useState } from 'react';

type Props = {
    className?: string;
    openLabel: string;
    closeLabel: string;
    modalTitle: string;
    hideCaret?: boolean;
    children: React.ReactNode;
};

export default function InlineModal({ modalTitle, openLabel, closeLabel, className, hideCaret, children }: Props) {
    const [isModalVisible, setIsModalVisible] = useState<boolean>(false);

    const toggleModal = () => {
        setIsModalVisible(!isModalVisible);
    };

    return (
        <div className={className ? className : ''}>
            <span
                className="inline-modal-trigger fake-link full-list"
                onClick={toggleModal}
            >
                {!hideCaret && <Icon type="caret-right" />} {openLabel}
            </span>

            <Modal
                centered
                className="wide-modal"
                title={modalTitle}
                visible={isModalVisible}
                onCancel={toggleModal}
                footer={null}
            >
                <div className="modal-content">{children}</div>
                <div className="button-footer">
                    <Button //@ts-ignore
                        type="secondary"
                        onClick={toggleModal}
                    >
                        {closeLabel}
                    </Button>
                </div>
            </Modal>
        </div>
    );
}
